import { ModalHeader } from 'reactstrap'

function CustomModalHeader({ toggle, title }) {
  return (
    <ModalHeader className='border-bottom pb-2 pl-4 ' toggle={() => toggle()}>
      {title}
    </ModalHeader>
  )
}

export default CustomModalHeader
